var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "e8902264-6a44-412c-91b6-b9f89c469794",
    "data-name": "illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ea135439-c39e-4848-bce4-b343b6d93fd0",
    "data-name": "telescope"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aa2c1a7b-1b7d-4125-ab9c-15be091d1c4e",
    "data-name": "line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M883,865H179a2,2,0,0,1,0-4H883a2,2,0,0,1,0,4Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,829H117a2,2,0,0,1,0-4H254a2,2,0,0,1,0,4Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947,829H839a2,2,0,0,1,0-4H947a2,2,0,0,1,0,4Z",
    style: {
      fill: "#1d1d1b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "aa1a15d2-8026-4c16-b153-fcf90446cac9",
    "data-name": "message"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M367.24,194.65c0-46.14-49.84-83.55-111.32-83.55s-111.33,37.41-111.33,83.55,49.84,83.56,111.33,83.56a147.24,147.24,0,0,0,22.46-1.71L303.63,301l5.91-33.1C343.93,253.67,367.24,226.21,367.24,194.65Z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.92,111.1c61.48,0,111.32,37.41,111.32,83.55,0,31.56-23.3,59-57.7,73.24L303.63,301,278.38,276.5a147.24,147.24,0,0,1-22.46,1.71c-61.49,0-111.33-37.41-111.33-83.56s49.84-83.55,111.33-83.55m0-3c-30.39,0-59,8.91-80.53,25.08-21.8,16.36-33.81,38.2-33.81,61.48s12,45.13,33.81,61.49c21.55,16.17,50.14,25.07,80.53,25.07a152.73,152.73,0,0,0,21.44-1.51l24.17,23.45a3,3,0,0,0,2.1.85,2.91,2.91,0,0,0,.92-.15,3,3,0,0,0,2-2.33l5.62-31.5c35.84-15.35,58-44.11,58-75.37,0-23.28-12-45.12-33.81-61.48C314.9,117,286.3,108.09,255.92,108.09Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.6,189.51H306.81a1.51,1.51,0,0,0,0-3H197.6a1.51,1.51,0,0,0,0,3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M237.69,217.78H301.3a1.5,1.5,0,0,0,0-3H237.69a1.5,1.5,0,1,0,0,3Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332,234.52q1.85-1.87,3.54-3.92l.78-1,.38-.49c.14-.18,0,0,0,0l.25-.32c.51-.68,1-1.38,1.5-2.08a61.5,61.5,0,0,0,5.1-8.88c.17-.36.33-.73.5-1.1l.24-.55s.13-.3.06-.13.08-.19.09-.22c.33-.81.65-1.62.94-2.43q.86-2.35,1.51-4.77t1.11-4.94c.07-.39.13-.78.19-1.18l.09-.59a2.54,2.54,0,0,0,0-.29c.05-.33,0,.28,0-.06.11-.81.2-1.64.27-2.46a55.45,55.45,0,0,0-.06-10c0-.41-.09-.82-.14-1.22,0-.19,0-.38-.07-.56.05.36,0-.2,0-.31-.12-.78-.25-1.56-.4-2.33-.3-1.55-.67-3.08-1.09-4.6s-.95-3.09-1.52-4.61c-.13-.35-.27-.71-.41-1.06l-.21-.54c0-.09-.26-.61-.13-.31-.33-.77-.67-1.52-1-2.27a62.81,62.81,0,0,0-4.88-8.45q-.69-1-1.41-2l-.36-.47-.16-.21c-.26-.34-.53-.67-.79-1q-1.59-2-3.31-3.78a66.72,66.72,0,0,0-7.34-6.65l-.36-.27-.49-.36c-.35-.26-.7-.52-1.06-.77a2.06,2.06,0,0,1-.72-2.75,2,2,0,0,1,2.74-.72,68.59,68.59,0,0,1,15.19,14.8,62.84,62.84,0,0,1,9.35,17.88,56.89,56.89,0,0,1,2.85,20.05A59.48,59.48,0,0,1,348.28,217a64.08,64.08,0,0,1-11.59,18.37c-.6.67-1.22,1.33-1.85,2a2,2,0,0,1-2.83,0,2,2,0,0,1,0-2.84Z",
    style: {
      fill: "#fff"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M218.42,147.09a1.5,1.5,0,0,0,.09-3c-46.46-3.1-84-28.93-107.35-50.06-25.35-23-39.86-45.47-40-45.7A1.51,1.51,0,0,0,68.62,50a258.55,258.55,0,0,0,40.46,46.26c23.7,21.46,61.88,47.72,109.23,50.88Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.68,183.42c2.72,0,5.51-.13,8.38-.41a1.5,1.5,0,0,0-.29-3c-53.09,5.16-80.94-41.86-81.22-42.34a1.5,1.5,0,0,0-2.6,1.5,98.36,98.36,0,0,0,21.15,23.95C119.66,172.69,138.11,183.42,162.68,183.42Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "edb2985a-fc9a-4d9f-b1e6-4c22fe769ed8",
    "data-name": "woman"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M515,410.1s76.59,183.32,243.4,191.07C884,607,875,599,904,553c25.38-40.26,36.27-162.89,12.67-189.15s-46-14.66-46-14.66L857,326.12l-88.64,29.09,5.54,17.2s-28.26,23-14.57,52.68,25.23,73.08,40.33,84.5c0,0-194.55-105.48-284.69-74.59",
    style: {
      fill: "#007be8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.18,604.31c-15,0-33.24-.59-55.86-1.64-38.3-1.78-75-13-109.1-33.34C622,553.08,596.32,531,573,503.7a413.29,413.29,0,0,1-48-69.95,87.43,87.43,0,0,0-9.55,2.67l-1-2.84c2.89-1,5.9-1.85,9-2.59-6.58-12.32-9.88-20.13-10-20.32l2.77-1.15c.08.19,3.47,8.2,10.23,20.81,37.87-7.71,93.29,2,165.07,29a1003.51,1003.51,0,0,1,100.79,44.8c-7.85-10.63-14.72-28.62-21.9-47.43-4-10.6-8.23-21.55-12.57-31-12.68-27.54,9.66-49.67,14.21-53.79l-5.7-17.68,91.21-29.93,13.54,23c5.29-2,25.69-7.64,46.53,15.55,11.12,12.37,15.76,46.18,12.42,90.44-3.18,42.08-13,81.53-24.93,100.51-2.79,4.42-5.28,8.58-7.47,12.25C880.74,594.55,874.89,604.31,814.18,604.31ZM528.11,433.12a410.62,410.62,0,0,0,47.22,68.7c36.3,42.45,97.53,93.88,183.13,97.85,112.6,5.23,115.81-.15,136.76-35.16,2.21-3.68,4.7-7.86,7.51-12.31,11.73-18.6,21.33-57.51,24.48-99.14,3.23-42.81-1.23-76.61-11.66-88.2-22.49-25-43.36-14.78-44.24-14.34l-1.26.65-.72-1.22-13-22-86.08,28.25,5.4,16.76-.79.64c-1.12.91-27.19,22.61-14.16,50.89,4.38,9.51,8.58,20.51,12.64,31.15,8.49,22.25,17.28,45.26,27.23,52.79L799,510.91a980.41,980.41,0,0,0-108.38-48.8C621,436,565.25,426.06,528.11,433.12Z",
    style: {
      fill: "#1d1d1b"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M423.34,349.36s-3.89,46.63-36.83,36.57S301,363.37,281.37,412.25s-28.48,83.3-65.56,82.06S131.91,604.7,231,636.41c162.33,52,281-241.41,281-241.41l-29.18-25.88Z",
    style: {
      fill: "#382256"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M423.34,349.36l59.42,19.76L511.94,395s-97.6,241.37-236.89,247.47A125.31,125.31,0,0,1,231,636.41c-97.78-31.31-53.41-140.48-16.58-142.09.48,0,1,0,1.43,0,1.46,0,2.86,0,4.23,0,33.55-1.47,42.43-35.08,61.33-82.05,10.42-25.9,30.08-34.57,51.15-35.49,18.69-.82,38.5,4.45,54,9.17a29.26,29.26,0,0,0,9.86,1.4c23.89-1,27-38,27-38m-.13-3a2.91,2.91,0,0,0-1.52.49,3,3,0,0,0-1.33,2.24c0,.46-3.19,34.32-24.12,35.24a26.84,26.84,0,0,1-8.86-1.27c-16.59-5.07-36.1-10.13-55-9.31-26.18,1.15-44.28,13.72-53.8,37.37-2.16,5.38-4.19,10.57-6.15,15.58-14.91,38.16-24.76,63.37-52.53,64.59-1.29.06-2.63.06-4,0-.55,0-1.1,0-1.66,0-9.71.42-19.82,7.17-28.48,19a92.08,92.08,0,0,0-16.29,41.49c-2.45,18.27.77,35.55,9.32,50C189,619,206.25,631.64,230.05,639.26a129.1,129.1,0,0,0,45.13,6.2c32.43-1.42,65.25-15.53,97.54-41.92,25.64-21,51-49.69,75.47-85.4,41.52-60.67,66.27-121.41,66.52-122a3,3,0,0,0-.79-3.35l-29.18-25.89a3.08,3.08,0,0,0-1-.6l-59.42-19.76a3,3,0,0,0-1.07-.14Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M482.76,369.12l-59.42-19.76s-1.92,23-14.46,33.2L451,423s-53,34-73,73c-13.45,26.23-64.7,143.8-29.65,121.54,31.14-19.78,58.88-49.13,82.27-80.08,24.25-61.61,52.22-132.73,62.47-159.18Z",
    style: {
      fill: "#050505"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M329,863s4-429,181.23-421.49C790.23,453.38,767.86,863,767.86,863Z",
    style: {
      fill: "#007be8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.28,864.5H327.49V863a1242.42,1242.42,0,0,1,14.12-159.6c7.8-49.87,18.31-93.69,31.23-130.24,16.19-45.8,36.27-80.29,59.66-102.5,22.7-21.56,48.87-31.86,77.79-30.64,65.35,2.77,119.68,27.53,161.47,73.59,25.14,27.69,45.91,63.32,61.73,105.88,12.65,34,22.19,72.5,28.35,114.41,10.5,71.32,7.54,128.62,7.51,129.19Zm-438.76-3h435.9c.38-9.24,2-62.42-7.54-127.24-9.64-65.47-33-156.54-89.34-218.65-41.23-45.44-94.85-69.86-159.37-72.6-28.08-1.2-53.51,8.84-75.59,29.81-52.28,49.64-77.79,153-90,231A1250.58,1250.58,0,0,0,330.52,861.5Z",
    style: {
      fill: "#1d1d1b"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 478.2,
    cy: 238.87,
    r: 42.07,
    style: {
      fill: "#382256"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M470.16,197.57a42.07,42.07,0,1,1-31.1,25.89,41.83,41.83,0,0,1,31.1-25.89m-.57-2.93a45,45,0,1,0,25.11,2.3,44.89,44.89,0,0,0-25.11-2.3Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M607.18,358.31s26.8-28,12-53-21.42-22.14-28.36-35.83-33.76-25.62-56.43-16.74c0,0-30.88-19-56.4-9.88s-33.49,22.44-39.06,43.54S426.78,317.27,422.36,332s-9.32,55.3,48.89,79.56S607.18,358.31,607.18,358.31Z",
    style: {
      fill: "#382256"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M483.91,241.27c24.13-4.71,50.47,11.5,50.47,11.5a44,44,0,0,1,7.56-2.2c20.74-4,42.69,6.74,48.87,18.94,6.94,13.69,13.55,10.81,28.36,35.83s-12,53-12,53-47,46.84-95.26,56.27c-13.81,2.7-27.73,2.34-40.67-3.05C413,387.27,417.94,346.67,422.36,332s11-24.45,16.56-45.54S452.47,252,478,242.89a41.69,41.69,0,0,1,5.93-1.62m-.57-2.93a43.77,43.77,0,0,0-6.36,1.74c-26.71,9.56-35.24,23.95-41,45.58a190.46,190.46,0,0,1-9.9,27.93,164.17,164.17,0,0,0-6.63,17.52,60.87,60.87,0,0,0,1,38.08c7,19.13,23.69,34.3,49.59,45.09,12.48,5.21,26.75,6.3,42.39,3.24,25.47-5,50.45-20.26,66.92-32.19a274.88,274.88,0,0,0,29.88-24.9l.05-.05a75.78,75.78,0,0,0,12.09-17.88c6.79-14.19,6.9-27.56.31-38.69-8.43-14.25-14.33-19.73-19.07-24.13-3.69-3.43-6.35-5.9-9.2-11.52-6.69-13.22-29.74-24.89-52.1-20.52a47.45,47.45,0,0,0-6.71,1.83c-5.72-3.26-29.12-15.47-51.32-11.13Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M501.27,339.49l-.13,0c-18.66,1.94-38.47-14.44-39.31-15.14a1.49,1.49,0,0,1,1.92-2.29c.2.16,19.69,16.27,37.08,14.46a1.49,1.49,0,0,1,.44,2.95Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M498.57,327.7a47.51,47.51,0,0,1-12.67.68,1.49,1.49,0,0,1,.22-3c36.8,2.72,44.54-35.08,44.85-36.69a1.5,1.5,0,0,1,2.94.57C533.84,289.65,527.24,322.1,498.57,327.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M537.61,420.32s80.42,51.26-18,59.14c0,0-13.49,35.57-50.81,24.7s-28.21-45.58-5.65-57.94C482.77,435.5,537.61,420.32,537.61,420.32Z",
    style: {
      fill: "#fff"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M490,507a45.44,45.44,0,0,1-21.57-1.4c-15.58-4.53-24.89-13.73-26.21-25.9-1.44-13.15,6.89-27.45,20.26-34.78,19.5-10.68,72.49-25.41,74.73-26a1.52,1.52,0,0,1,1.21.18c1.46.93,35.77,23.05,31.23,41.32-2.77,11.12-19.24,18-49,20.5C518.79,485.11,509.65,503.14,490,507Zm47.36-85.05c-6.24,1.75-55.39,15.71-73.44,25.59-12.14,6.65-20,20-18.73,31.84,1.19,10.88,9.74,19.17,24.08,23.35,14.93,4.35,27.7,1.69,38-7.92a47.8,47.8,0,0,0,11-15.87,1.48,1.48,0,0,1,1.28-1c28.47-2.28,44.79-8.61,47.21-18.31C570.49,444.62,541.74,424.85,537.36,421.94Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M429.78,207.46a1.45,1.45,0,0,1-.51,0,1.49,1.49,0,0,1-1.26-1.7c1.52-10.12,5.8-17.84,12.74-22.93,12.22-9,28.16-6.58,28.83-6.47a1.48,1.48,0,0,1,1.24,1.7,1.5,1.5,0,0,1-1.71,1.25c-.15,0-15.41-2.29-26.61,5.94-6.26,4.61-10.14,11.66-11.53,21A1.5,1.5,0,0,1,429.78,207.46Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M474.17,619s10.14,42.58,174,74.76,194-40.88,192.41-88.45,1.66-132.54-20.78-159.8-45.36-16.65-45.36-16.65l-12.58-23.64-89.82,25.21,4.79,17.43s-29.23,21.71-16.85,52S682,574,696.61,586c0,0-165.16-160.62-252.24-81.5",
    style: {
      fill: "#007be8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.31,703.22q-32.61,0-73.42-8c-162.94-32-174.75-74.1-175.18-75.88l2.92-.71c0,.11,2.93,10.58,25.59,24.84,20.95,13.19,63.5,32.36,147.25,48.81,76,14.91,130.53,8.84,162.15-18.06,26-22.13,29-52.65,28.47-68.87-.26-8-.38-17-.52-26.55-.66-46.44-1.56-110-19.92-132.35-21.38-26-42.68-16.65-43.57-16.24l-1.29.59-.66-1.25-12-22.57-87.22,24.48,4.67,17-.82.61c-1.16.86-28.15,21.4-16.36,50.23,4,9.68,7.68,20.85,11.27,31.66,7,21,14.21,42.68,22.91,52,1.33,1.24,2.05,1.93,2.1,2l-2,2.23a23,23,0,0,1-2.24-2.11c-9.13-8.54-46.29-42.22-91.07-68.19-30.12-17.46-57.73-28.07-82.06-31.51-30.2-4.28-55.4,2.54-74.91,20.27l-2-2.22c20.21-18.36,46.24-25.44,77.37-21,24.72,3.5,52.71,14.24,83.17,31.91,35.6,20.65,66.41,46.15,82.3,60.17-5.9-11-11.05-26.51-16.39-42.58-3.58-10.76-7.29-21.89-11.21-31.48-11.48-28.07,11.8-49.2,16.53-53.12l-4.93-17.91,92.42-25.94L775.16,427c5.37-1.78,26-6.51,45.81,17.56,19,23.12,19.9,84.72,20.6,134.22.14,9.54.26,18.56.52,26.49.55,16.76-2.55,48.31-29.52,71.25C791.65,694.3,761.08,703.22,721.31,703.22Z",
    style: {
      fill: "#1d1d1b"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M679,449s34,31,95-18l-13-23-86,24Z",
    style: {
      fill: "#0598c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.7,372.91s35.28,29.53,94.16-22l-14-22.43L772,356.09Z",
    style: {
      fill: "#0598c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.61,232.69a1.61,1.61,0,0,1-.72,0,1.51,1.51,0,0,1-1-1.88c3.22-10.36,8.73-17.39,16.37-20.88,12.38-5.64,25.71.08,26.27.33a1.5,1.5,0,1,1-1.2,2.74c-.13-.06-12.72-5.43-23.85-.34-6.82,3.12-11.78,9.53-14.73,19A1.51,1.51,0,0,1,448.61,232.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M535.74,430.8,539,447.2s-20.1,48.21-81.62,23.9c0,0,19.28-43.79,24.7-92.35,0,0-21.31-1.54-20.7-20.48s15-24.23,24.5-20.49c0,0,37.75,19,62.42-57.63,0,0,38.64,9.74,51.62,46.36s11.81,81.37-15.33,98.08S535.74,430.8,535.74,430.8Z",
    style: {
      fill: "#ffcdb2"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M548.25,280.15s38.64,9.74,51.62,46.36,11.81,81.37-15.33,98.08a63.15,63.15,0,0,1-21.07,8.46c-16.46,3.21-27.73-2.25-27.73-2.25L539,447.2S528.84,471.44,501,476.88c-11.41,2.23-25.8,1.29-43.7-5.78,0,0,19.28-43.79,24.7-92.35,0,0-21.31-1.54-20.7-20.48.42-13.25,7.6-19.82,15.13-21.29a16.84,16.84,0,0,1,9.37.8s6.77,3.4,16.44,1.51c13.18-2.58,31.75-15,46-59.14m-.57-2.93a3,3,0,0,0-2.27,2c-13.81,42.84-31.39,54.7-43.71,57.11a24.93,24.93,0,0,1-14.54-1.25,1.15,1.15,0,0,0-.23-.1,20.1,20.1,0,0,0-11.05-1c-8.16,1.6-17.05,8.78-17.54,24.13-.29,9,3.76,15.92,11.72,20.09a32.69,32.69,0,0,0,8.67,3c-5.72,46.39-23.94,88.2-24.13,88.63a3,3,0,0,0,1.64,4c16.62,6.57,31.89,8.57,45.37,5.93,29-5.68,39.66-30.41,40.1-31.46a2.89,2.89,0,0,0,.17-1.72l-2.21-11.31A53.82,53.82,0,0,0,564,436a66.44,66.44,0,0,0,22.07-8.84c13.42-8.27,21.76-23.41,24.11-43.78,2.06-17.8-.62-38.35-7.53-57.85-5.54-15.62-16.57-28.92-31.92-38.45A84.7,84.7,0,0,0,549,277.25a3,3,0,0,0-1.3,0Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M536.9,433.8a1.55,1.55,0,0,1-.48,0c-17.77-2.3-33.29-17.49-33.94-18.13a1.5,1.5,0,0,1,2.1-2.13c.15.15,15.47,15.13,32.22,17.3a1.5,1.5,0,0,1,.1,2.95Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M480.84,370.05a1.48,1.48,0,0,1-1.44-.53c-5.09-6.24-6.87-11.76-5.29-16.38,2.27-6.66,10.6-8.68,10.95-8.77a1.5,1.5,0,0,1,.69,2.91c-.09,0-7.1,1.75-8.82,6.84-1.21,3.58.4,8.13,4.79,13.52a1.49,1.49,0,0,1-.22,2.1A1.54,1.54,0,0,1,480.84,370.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M557.58,336.16c-20.9,5.74-50-1.86-54.42,6s-.14,17.76,11.47,19.59,23,.82,46.15-2.38S606.42,351.28,603,339,588.31,327.71,557.58,336.16Z",
    style: {
      fill: "#ffb49f"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 473.48,
    cy: 379.27,
    r: 6.89,
    style: {
      fill: "#007be8"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M472.17,372.51A6.89,6.89,0,0,1,474.8,386a6.79,6.79,0,0,1-3.84-.35,6.89,6.89,0,0,1,1.21-13.17m-.57-2.93a9.86,9.86,0,1,0,5.5.5,9.83,9.83,0,0,0-5.5-.5Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 583.27,
    cy: 346.64,
    r: 3.9
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M528.84,341.15a1.5,1.5,0,0,1-.82-2.87c.12,0,11.54-4.45,11.38-12a1.5,1.5,0,0,1,1.47-1.52,1.48,1.48,0,0,1,1.52,1.46c.2,9.64-12.76,14.63-13.31,14.84Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M466,466.49a1.47,1.47,0,0,1-1-.17,1.49,1.49,0,0,1-.54-2c11.63-20,19.67-59.81,19.76-60.21A1.48,1.48,0,0,1,486,402.9a1.5,1.5,0,0,1,1.18,1.76c-.33,1.65-8.23,40.65-20.11,61.12A1.48,1.48,0,0,1,466,466.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.63,410.24h-.13c-10.29-.08-18.33-9.88-18.67-10.3a1.5,1.5,0,1,1,2.34-1.88c.07.09,7.5,9.12,16.36,9.18h.1c4.4,0,8.51-2.25,12.22-6.69a1.5,1.5,0,0,1,2.3,1.93C557.84,407.63,553,410.24,547.63,410.24Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M740.45,286.66c-21.85-11.54-33.51-4.37-26,17.38s56.86,47.11,56.86,47.11l80-23.22",
    style: {
      fill: "#ffcdb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.11,353.29l-.71-.36c-2-1.05-50.16-26-57.84-48.24-4.68-13.54-1.66-19.81,1.69-22.68,5.33-4.57,15-3.54,27.14,2.88l-1.87,3.54c-10.46-5.53-18.72-6.76-22.66-3.38-3.41,2.92-3.6,9.43-.52,18.34,6.69,19.37,49.2,42.44,55.19,45.61l79.22-23,1.11,3.85Z",
    style: {
      fill: "#1d1e1b"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M850.21,326.83l-6.35-10.89s8.47-11.92,4.81-46c-5.79-53.82-46.33-41.26-46.33-41.26-17.71-14.56-35.69,3.79-35.69,3.79s-23.94-29.17-38.29,11.11c-8.21,23,8.3,51.36,24.35,72.24",
    style: {
      fill: "#ffcdb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.92,327.58l-6.85-11.71.56-.79c.08-.12,8.08-12.06,4.55-45-1.9-17.66-7.76-29.85-17.43-36.23-12.33-8.12-26.83-3.81-27-3.76l-.77.24-.63-.52c-16.41-13.5-33,3-33.66,3.69l-1.17,1.18-1.06-1.28c-.09-.11-9.36-11.19-19.14-9.48-6.65,1.17-12.23,7.94-16.58,20.14-6.37,17.89,1.75,41.71,24.13,70.82l-2.37,1.83c-23-30-31.32-54.75-24.59-73.66,4.74-13.29,11.1-20.72,18.91-22.09,9.51-1.66,18,6.26,20.91,9.35,4.38-3.79,20.22-15.58,35.91-3.3,3.38-.87,16.73-3.55,28.7,4.32,10.47,6.88,16.79,19.81,18.79,38.43,3.19,29.68-2.7,42.85-4.56,46.16l5.91,10.11Z",
    style: {
      fill: "#1d1e1b"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M519,357.5a1.5,1.5,0,0,1-.17-3l27-3a1.5,1.5,0,0,1,.34,3l-27,3Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M645.05,356.49c-23-13.64-36-6.5-29.06,17.43s59,54,59,54L762.82,407",
    style: {
      fill: "#ffcdb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.73,430l-.69-.4c-2.16-1.24-52.85-30.73-60-55.15-4.32-14.8-.77-21.37,3-24.27,6-4.62,16.26-3,29,4.56l-2,3.44c-11.1-6.57-20-8.33-24.54-4.84-3.9,3-4.46,10.12-1.58,20,6.25,21.44,51.34,48.79,57.45,52.41l87-20.71.93,3.89Z",
    style: {
      fill: "#1d1e1b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "ac90454b-640f-416e-addb-39b5f31c4bfa",
    "data-name": "telescope"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M842.25,267.18c-75.8,32.5-153.6,60.14-228,95.78q-8.72-17.15-17.41-34.3c72.73-38.94,141.24-85,212.33-126.71Z",
    style: {
      fill: "#382256"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.54,365,594.8,328l1.3-.7c45.27-24.23,89.66-51.68,132.59-78.23,26-16.08,52.88-32.7,79.69-48.45l1.37-.8,34.56,68.08-1.47.63c-28.59,12.26-57.94,24-86.32,35.38-46.87,18.78-95.33,38.19-141.66,60.37Zm-14.73-35.66L614.89,361c46-22,94.05-41.21,140.51-59.82,27.88-11.17,56.69-22.71,84.78-34.73l-31.66-62.38c-26.33,15.49-52.72,31.81-78.25,47.6C687.71,278,643.71,305.18,598.81,329.29Z",
    style: {
      fill: "#1d1e1b"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M626.75,362.47c-5.58,2.59-9.76,4.57-15.31,7.31a5.16,5.16,0,0,1-6.88-2.29L587,332.89a5.16,5.16,0,0,1,2.21-6.9c5.49-2.87,9.56-5.06,14.95-8.05a5.16,5.16,0,0,1,7.1,2.18l17.93,35.34A5.15,5.15,0,0,1,626.75,362.47Z",
    style: {
      fill: "#4bd657"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.18,371.81a6.7,6.7,0,0,1-6-3.64l-17.55-34.6a6.67,6.67,0,0,1,2.85-8.91c5.37-2.81,9.42-5,14.91-8a6.66,6.66,0,0,1,9.16,2.81l17.94,35.34a6.66,6.66,0,0,1-3.15,9.06h0c-5.71,2.63-9.85,4.61-15.28,7.29A6.58,6.58,0,0,1,609.18,371.81Zm-2.53-53a3.71,3.71,0,0,0-1.77.46c-5.51,3.07-9.57,5.25-15,8.07a3.66,3.66,0,0,0-1.57,4.89l17.56,34.6a3.67,3.67,0,0,0,4.88,1.63c5.45-2.69,9.61-4.68,15.35-7.33a3.64,3.64,0,0,0,1.72-5L609.92,320.8a3.58,3.58,0,0,0-2.19-1.84A3.64,3.64,0,0,0,606.65,318.79Z",
    style: {
      fill: "#1d1e1b"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M865,269.73c-39.07,16.67-78.9,31.3-118.76,45.95a9.2,9.2,0,0,1-11.38-4.48Q722.39,286.75,710,262.28a9.2,9.2,0,0,1,3.14-11.85c35.44-23.35,70.86-46.69,107.41-68.28a9.21,9.21,0,0,1,12.91,3.75q18.06,35.6,36.13,71.19A9.22,9.22,0,0,1,865,269.73Z",
    style: {
      fill: "#4bd657"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743,317.74a10.7,10.7,0,0,1-9.55-5.86L708.64,263a10.69,10.69,0,0,1,3.66-13.78l.17-.11c34.79-22.93,70.77-46.64,107.3-68.21a10.82,10.82,0,0,1,8.47-1.07,10.63,10.63,0,0,1,6.54,5.43l36.13,71.19a10.62,10.62,0,0,1,.51,8.5,10.77,10.77,0,0,1-5.88,6.2h0c-39,16.64-79.45,31.5-118.55,45.87l-.28.11A10.84,10.84,0,0,1,743,317.74Zm82.19-135.38a7.77,7.77,0,0,0-3.92,1.08c-36.46,21.53-72.41,45.22-107.17,68.13l-.17.11a7.69,7.69,0,0,0-2.63,9.92l24.82,48.93a7.71,7.71,0,0,0,9.53,3.74l.28-.1C785,299.81,825.42,285,864.36,268.35h0a7.71,7.71,0,0,0,3.87-10.58L832.1,186.58a7.63,7.63,0,0,0-4.7-3.91A7.88,7.88,0,0,0,825.21,182.36Z",
    style: {
      fill: "#1d1e1b"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M894.52,198.58c7,13.8,24.48,57.36,3.36,67.18C877,275.47,853,237.84,845.64,223.39s-23.53-56-3.36-67.18C862.68,145,887.52,184.79,894.52,198.58Z",
    style: {
      fill: "#4bd657"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.87,268.82c-18.64,0-38-28-46.57-44.75-9.69-19.1-22.74-58.14-2.74-69.17a17.61,17.61,0,0,1,14.16-1.24c20.72,6.38,39.36,42.7,40.14,44.25s19.1,38,12,58.51a17.56,17.56,0,0,1-9.36,10.7A17.89,17.89,0,0,1,890.87,268.82Zm-41-113.09a13.87,13.87,0,0,0-6.83,1.8c-18.66,10.29-3.47,50.54,4,65.18s30.95,50.68,50.28,41.69a14.52,14.52,0,0,0,7.79-9c5.34-15.44-5.42-43.5-11.86-56.18s-22.73-37.93-38.34-42.73A16.75,16.75,0,0,0,849.84,155.73Z",
    style: {
      fill: "#1d1e1b"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M897.88,265.76q-11.07,5.07-22.2,9.88A9.83,9.83,0,0,1,863,271.08L817.4,181.22a9.83,9.83,0,0,1,3.81-12.92q10.47-6.15,21.07-12.09Q870.08,211,897.88,265.76Z",
    style: {
      fill: "#382256"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.78,278a11.34,11.34,0,0,1-10.11-6.19l-45.6-89.86a11.35,11.35,0,0,1,4.38-14.9c7-4.1,14.09-8.18,21.1-12.1l1.36-.76,57,112.34-1.42.65c-7.3,3.34-14.78,6.66-22.22,9.88A11.18,11.18,0,0,1,871.78,278ZM841.65,158.29c-6.55,3.67-13.16,7.47-19.68,11.3a8.35,8.35,0,0,0-3.23,10.95l45.6,89.86a8.35,8.35,0,0,0,10.75,3.86c6.94-3,13.91-6.1,20.74-9.21Z",
    style: {
      fill: "#1d1e1b"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M724.5,258.54a3,3,0,0,1-1.58-5.55l89.5-55.54a3,3,0,0,1,3.16,5.1l-89.5,55.54A2.94,2.94,0,0,1,724.5,258.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885,267a3,3,0,0,1-2.65-1.6l-19-36a3,3,0,0,1,5.3-2.8l19,36A3,3,0,0,1,885,267Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M761.7,405.75l-6.3-12.12s9.79-12.45,7.63-49.5c-3.42-58.56-48-47.1-48-47.1-18.39-16.69-38.82,2.22-38.82,2.22s-24.37-32.83-42,10c-10.1,24.48,6.27,56,22.55,79.46",
    style: {
      fill: "#ffcdb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.37,406.44l-6.75-13,.6-.76c.09-.12,9.41-12.65,7.31-48.49-1.12-19.26-6.84-32.8-17-40.22-12.95-9.48-28.93-5.56-29.09-5.52l-.78.2-.6-.54c-17.17-15.59-36,1.47-36.79,2.21l-1.22,1.13-1-1.34c-.09-.13-9.56-12.67-20.33-11.31-7.31.91-13.74,8-19.1,21-7.86,19.06-.33,45.32,22.39,78l-2.47,1.71c-23.33-33.6-31-60.82-22.7-80.88,5.81-14.1,13-21.78,21.52-22.83,10.42-1.31,19.22,7.85,22.11,11.27,4.78-3.78,22.63-15.93,39-1.72,3.57-.74,18.22-3,30.78,6.15,10.94,8,17.08,22.28,18.26,42.49,1.89,32.46-5.26,46.34-7.39,49.7L763,405.05Z",
    style: {
      fill: "#1d1e1b"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M680.15,354.93a1.52,1.52,0,0,1-1.36-.85c-13.85-28.73-3.86-54-3.43-55.05a1.5,1.5,0,0,1,2.78,1.13c-.1.25-9.9,25.13,3.36,52.62a1.5,1.5,0,0,1-.7,2A1.54,1.54,0,0,1,680.15,354.93Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.29,353.32a1.18,1.18,0,0,1-.37-.05,1.49,1.49,0,0,1-1.08-1.82c6.66-26.12-3.44-53.7-3.54-54a1.5,1.5,0,1,1,2.81-1.05c.43,1.16,10.52,28.74,3.63,55.76A1.49,1.49,0,0,1,718.29,353.32Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.62,
    cy: 827.08,
    r: 8.14,
    style: {
      fill: "#51cef4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.62,
    cy: 706.08,
    r: 8.14,
    style: {
      fill: "#51cef4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 544.62,
    cy: 714.08,
    r: 8.14,
    style: {
      fill: "#51cef4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503.62,
    cy: 774.08,
    r: 8.14,
    style: {
      fill: "#51cef4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624.62,
    cy: 846.08,
    r: 8.14,
    style: {
      fill: "#51cef4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 721.62,
    cy: 748.08,
    r: 8.14,
    style: {
      fill: "#51cef4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.62,
    cy: 637.08,
    r: 8.14,
    style: {
      fill: "#51cef4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774.62,
    cy: 652.08,
    r: 8.14,
    style: {
      fill: "#51cef4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.62,
    cy: 521.08,
    r: 8.14,
    style: {
      fill: "#51cef4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 796.62,
    cy: 560.08,
    r: 8.14,
    style: {
      fill: "#51cef4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 793.62,
    cy: 480.08,
    r: 8.14,
    style: {
      fill: "#51cef4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 550.62,
    cy: 542.08,
    r: 8.14,
    style: {
      fill: "#51cef4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 822.62,
    cy: 403.08,
    r: 8.14,
    style: {
      fill: "#51cef4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 910.62,
    cy: 406.08,
    r: 8.14,
    style: {
      fill: "#51cef4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 876.62,
    cy: 506.08,
    r: 8.14,
    style: {
      fill: "#51cef4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 865.62,
    cy: 440.08,
    r: 8.14,
    style: {
      fill: "#51cef4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.62,
    cy: 581.08,
    r: 8.14,
    style: {
      fill: "#51cef4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748,384a2.91,2.91,0,0,1-.82-.12,3,3,0,0,1-2.06-3.7c9.52-33.34-2.66-57.56-2.78-57.8a3,3,0,1,1,5.32-2.76c.55,1.06,13.44,26.47,3.22,62.2A3,3,0,0,1,748,384Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630,563a3,3,0,0,1-1.83-.62c-58.17-44.91-98.6-53-122.28-51.88-25.05,1.18-36.65,12.51-36.77,12.62a3,3,0,0,1-4.24-4.24c.53-.54,13.38-13.09,40.73-14.38,35.9-1.67,78.37,16.18,126.22,53.13A3,3,0,0,1,630,563Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.4,485.9q-8.21,0-16.56-.82c-24.88-2.42-50.78-10.26-77-23.29-44.52-22.14-75-52.07-75.27-52.37a2,2,0,0,1,2.82-2.84c.3.3,30.35,29.84,74.33,51.68,40.39,20.06,101.18,37.56,161.35,7a2,2,0,1,1,1.82,3.56A156,156,0,0,1,212.4,485.9Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,547a178.81,178.81,0,0,1-34.11-3.53,255.52,255.52,0,0,1-50.7-15.64,2,2,0,0,1,1.66-3.64c.87.39,87.53,39.1,136,4.2a2,2,0,0,1,2.34,3.24C225,541.82,206.26,547,184,547Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950,483a1.72,1.72,0,0,1-.39,0,2,2,0,0,1-1.57-2.35c22.26-111.33-8.58-127.65-8.89-127.8a2,2,0,0,1-.95-2.65,2,2,0,0,1,2.63-1c1.4.64,34.18,17,11.13,132.21A2,2,0,0,1,950,483Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.43,728.26a188.73,188.73,0,0,1-40.92-4.32,2,2,0,0,1,1-3.88,187.81,187.81,0,0,0,55.09,3.56c39.93-3.45,69.45-19.83,87.74-48.69a2,2,0,0,1,3.38,2.14c-18.75,29.58-50.18,47.06-90.89,50.55C747.48,728.07,742.33,728.26,737.43,728.26Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820,140a2,2,0,0,1-1.42-.59,2,2,0,0,1,0-2.82c.68-.69,17-16.76,38-16.76h.32c11.52.08,22.14,5,31.56,14.77a2,2,0,0,1-2.88,2.78c-8.63-8.91-18.29-13.47-28.68-13.55h-.31c-19.31,0-35,15.43-35.16,15.59A2,2,0,0,1,820,140Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.5,376a1.5,1.5,0,0,1-1.39-.94l-13-32a1.5,1.5,0,0,1,2.78-1.12l13,32a1.5,1.5,0,0,1-.83,1.95A1.55,1.55,0,0,1,573.5,376Z",
    style: {
      fill: "#1d1d1b"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/coming-soon.f46315c0ad41f22812c7358e2e9e4880.svg";
export { ForwardRef as ReactComponent };